(function () {
  'use strict';
  function initSection(root) {
    if (!root || root.vcInited) return;
    root.vcInited = true; 

    const modal = root.querySelector('.vc-modal');
    let modalToUse = modal;
    if (!modalToUse) {
      modalToUse = createInlineModal();
      root.appendChild(modalToUse);
    }
    
    modalToUse.style.overflow = 'visible';

    const mediaWrap = modalToUse.querySelector('.vc-media-wrap');
    const closeBtn = modalToUse.querySelector('.vc-modal-close');
    const overlay = modalToUse.querySelector('.vc-modal-overlay');
    const modalContent = modalToUse.querySelector('.vc-modal-content');
    
    modalContent.style.zIndex = '2';

    if (!modalToUse.querySelector('.vc-modal-preview.prev')) {

      const prevPreview = document.createElement('div');
      prevPreview.className = 'vc-modal-preview prev hidden';
      prevPreview.innerHTML = '<img src="" alt="上一个视频" />';
      modalToUse.appendChild(prevPreview);

      const nextPreview = document.createElement('div');
      nextPreview.className = 'vc-modal-preview next hidden';
      nextPreview.innerHTML = '<img src="" alt="下一个视频" />';
      modalToUse.appendChild(nextPreview);
    }
    
    const prevPreviewEl = modalToUse.querySelector('.vc-modal-preview.prev');
    const nextPreviewEl = modalToUse.querySelector('.vc-modal-preview.next');
    const prevPreviewImg = prevPreviewEl.querySelector('img');
    const nextPreviewImg = nextPreviewEl.querySelector('img');

    const videoItems = Array.from(root.querySelectorAll('.swiper-slide .vc-cover'));
    let currentVideoIndex = -1;
    let currentVideoElement = null;

    const swiperEl = root.querySelector('.vc-swiper');
    let swiperInstance = null;
    if (swiperEl && window.Swiper) {
      try {
        swiperInstance = new Swiper(swiperEl, {
          slidesPerView: 'auto',
          navigation: {
            nextEl: root.querySelector('.vc-swiper-button-next'),
            prevEl: root.querySelector('.vc-swiper-button-prev'),
          },
        });
        root.vcSwiper = swiperInstance;
      } catch (err) {
        console.warn('vc-swiper init failed', err);
      }
    }

    let lastFocusedElement = null;

    function renderPreviewAngles() {
      if (videoItems.length <= 1) {
        prevPreviewEl.classList.add('hidden');
        nextPreviewEl.classList.add('hidden');
        return;
      }

      const prevIndex = currentVideoIndex === 0 ? videoItems.length - 1 : currentVideoIndex - 1;
      const nextIndex = currentVideoIndex === videoItems.length - 1 ? 0 : currentVideoIndex + 1;

      const prevCoverEl = videoItems[prevIndex];
      const prevCoverImg = prevCoverEl.querySelector('.vc-cover-img');
      const prevCoverSrc = prevCoverImg ? prevCoverImg.src : '';
      const nextCoverEl = videoItems[nextIndex];
      const nextCoverImg = nextCoverEl.querySelector('.vc-cover-img');
      const nextCoverSrc = nextCoverImg ? nextCoverImg.src : '';

      if (prevCoverSrc) {
        prevPreviewImg.src = prevCoverSrc;
        const prevTitle = prevCoverEl.closest('.vc-item').querySelector('.vc-title')?.textContent || '上一个视频';
        prevPreviewImg.alt = `上一个视频：${prevTitle}`;
        prevPreviewEl.classList.remove('hidden');
      } else {
        prevPreviewEl.classList.add('hidden');
      }

      if (nextCoverSrc) {
        nextPreviewImg.src = nextCoverSrc;
        const nextTitle = nextCoverEl.closest('.vc-item').querySelector('.vc-title')?.textContent || '下一个视频';
        nextPreviewImg.alt = `下一个视频：${nextTitle}`;
        nextPreviewEl.classList.remove('hidden');
      } else {
        nextPreviewEl.classList.add('hidden');
      }
    }

    function removeVideoEventListeners() {
      if (currentVideoElement) {
        currentVideoElement.removeEventListener('ended', handleVideoEnded);
        currentVideoElement = null;
      }
    }

    function handleVideoEnded() {
      if (videoItems.length <= 1) return;
      
      switchVideo(true);
    }

    function openModalFromSlide(coverEl, direction) {
      removeVideoEventListeners();
      
      if (!coverEl || !modalToUse || !mediaWrap) return;
      
      currentVideoIndex = videoItems.findIndex(item => item === coverEl);
      
      if (currentVideoIndex === -1) {
        const blockIndex = coverEl.getAttribute('data-block-index');
        if (blockIndex !== null) {
          currentVideoIndex = parseInt(blockIndex, 10);
        }
      }

      const slide = coverEl.closest('.swiper-slide');
      if (!slide) {
        console.error('未找到对应的slide元素');
        return;
      }
      
      const videoHtml = slide.querySelector('.vc-video-html');
      if (!videoHtml) {
        console.error('未找到视频HTML内容');
        return;
      }

      lastFocusedElement = coverEl;
      modalToUse.classList.add('open');
      modalToUse.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');

      mediaWrap.innerHTML = videoHtml.innerHTML || '';
      const v = mediaWrap.querySelector('video');
      if (v) {
        currentVideoElement = v;
        
        v.addEventListener('ended', handleVideoEnded);
        
        try { 
          v.muted = false; 
          v.playsInline = true;
        } catch (e) {
          console.warn('设置视频属性失败:', e);
        }
        if (v.play) {
          v.play().catch(err => {
            console.warn('自动播放失败:', err);
          });
        }
      } else {
        console.warn('未找到视频元素');
      }

      const unmuteHandler = () => {
        const v2 = mediaWrap.querySelector('video');
        if (v2) try { v2.muted = false; } catch (e) {}
        mediaWrap.removeEventListener('click', unmuteHandler);
      };
      mediaWrap.addEventListener('click', unmuteHandler);

      overlay.style.display = 'block';
      
      renderPreviewAngles();
      
      if (direction === 'next') {
        modalContent.classList.add('animating-in-next');
      } else if (direction === 'prev') {
        modalContent.classList.add('animating-in-prev');
      }
      
      setTimeout(() => {
        modalContent.classList.remove('animating-in-next', 'animating-in-prev');
      }, 400); 
    }

    function switchVideo(isNext) {
      if (videoItems.length === 0) return;
      
      if (currentVideoIndex === -1 || currentVideoIndex >= videoItems.length) {
        currentVideoIndex = 0;
      }
      
      const direction = isNext ? 'next' : 'prev';
      modalContent.classList.add(`transitioning-${direction}`);
      
      let targetIndex;
      if (isNext) {
        targetIndex = currentVideoIndex === videoItems.length - 1 ? 0 : currentVideoIndex + 1;
      } else {
        targetIndex = currentVideoIndex === 0 ? videoItems.length - 1 : currentVideoIndex - 1;
      }

      const targetCover = videoItems[targetIndex];
      if (targetCover) {
        if (currentVideoElement) {
          currentVideoElement.pause();
          removeVideoEventListeners();
        }
        
        setTimeout(() => {
          modalContent.classList.remove(`transitioning-${direction}`);
          
          openModalFromSlide(targetCover, direction);
          
          if (swiperInstance) {
            swiperInstance.slideTo(targetIndex);
          }
        }, 400); 
      }
    }

    function closeModal() {
      if (!modalToUse) return;
      
      removeVideoEventListeners();
      
      modalContent.classList.add('closing');
      
      setTimeout(() => {
        modalToUse.classList.remove('open');
        modalToUse.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('modal-open');

        if (mediaWrap) {
          const vids = mediaWrap.querySelectorAll('video');
          vids.forEach(vv => {
            try { vv.pause(); } catch (e) {}
          });
          mediaWrap.innerHTML = '';
        }

        prevPreviewEl.classList.add('hidden');
        nextPreviewEl.classList.add('hidden');
        prevPreviewImg.src = '';
        nextPreviewImg.src = '';

        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
        }
        lastFocusedElement = null;
        currentVideoIndex = -1;
        overlay.style.display = 'none';
        
        modalContent.classList.remove('closing');
      }, 300);
    }

    let startX = 0;
    let isDragging = false;
    let startY = 0;
    let isVerticalSwipe = false;

    mediaWrap.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isVerticalSwipe = false;
    }, { passive: true });

    mediaWrap.addEventListener('touchmove', (e) => {
      if (!isVerticalSwipe) {
        const deltaY = Math.abs(e.touches[0].clientY - startY);
        const deltaX = Math.abs(e.touches[0].clientX - startX);
        if (deltaY > deltaX) {
          isVerticalSwipe = true; 
        }
      }
    }, { passive: true });

    mediaWrap.addEventListener('touchend', (e) => {
      if (isVerticalSwipe || e.changedTouches.length === 0) return;
      
      const endX = e.changedTouches[0].clientX;
      const deltaX = endX - startX;

      if (deltaX < -50) {
        switchVideo(true); 
      } else if (deltaX > 50) {
        switchVideo(false); 
      }
    });

    mediaWrap.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      startY = e.clientY;
      isDragging = true;
      isVerticalSwipe = false;
      mediaWrap.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      
      if (!isVerticalSwipe) {
        const deltaY = Math.abs(e.clientY - startY);
        const deltaX = Math.abs(e.clientX - startX);
        if (deltaY > deltaX) {
          isVerticalSwipe = true;
        }
      }
      
      mediaWrap.style.cursor = 'grabbing';
    });

    document.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      mediaWrap.style.cursor = 'pointer';

      if (isVerticalSwipe) return;
      
      const endX = e.clientX;
      const deltaX = endX - startX;

      if (deltaX < -50) {
        switchVideo(true);
      } else if (deltaX > 50) {
        switchVideo(false);
      }
    });

    root.querySelectorAll('.vc-cover').forEach(cover => {
      cover.addEventListener('click', () => {
        openModalFromSlide(cover);
      });
    });

    root.querySelectorAll('.vc-play-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        const cover = btn.closest('.vc-cover');
        if (cover) {
          openModalFromSlide(cover);
        }
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        closeModal();
      });
    }
    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }

    root.vcOpenModal = openModalFromSlide;
    root.vcCloseModal = closeModal;
    root.vcSwitchVideo = switchVideo;
  }

  function createInlineModal() {
    const div = document.createElement('div');
    div.className = 'vc-modal';
    div.setAttribute('aria-hidden', 'true');
    div.innerHTML = `
      <div class="vc-modal-overlay" data-close="true"></div>
      <div class="vc-modal-content" role="dialog" aria-modal="true" aria-label="Playback Window">
        <button class="vc-modal-close" aria-label="close">
          <svg focusable="false" viewBox="0 0 14 14" width="18px" height="18px" fill="none">
            <path d="M13 13L1 1M13 1L1 13" stroke="white" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </button>
        <div class="vc-media-wrap"></div>
      </div>
    `;
    return div;
  }

  function vcInitAllSections() {
    document.querySelectorAll('.vc-section').forEach(initSection);
  }

  if (!window._vcEscListenerAdded) {
    window._vcEscListenerAdded = true;
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' || e.keyCode === 27) {
        document.querySelectorAll('.vc-section .vc-modal.open, .vc-modal.open').forEach(m => {
          const section = m.closest('.vc-section');
          if (section && section.vcCloseModal) {
            section.vcCloseModal();
          } else {
            m.classList.remove('open');
            m.setAttribute('aria-hidden', 'true');
            const mediaWrap = m.querySelector('.vc-media-wrap');
            if (mediaWrap) {
              mediaWrap.querySelectorAll('video').forEach(vv => {
                try { vv.pause(); } catch (err) {}
              });
              mediaWrap.innerHTML = '';
            }
          }
        });
      }
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(vcInitAllSections);
  window.vcInitAllSections = vcInitAllSections;
})();